import {
    ORDERDETAILS_REQUEST,
    ORDERDETAILS_ERROR,
    ORDERDETAILS_SUCCESS,
    SETORDERDETAILS,
    ORDERDETAILS_params
} from "../actions/ordersDetails";
import apiCalls from "utils/api";
import Vue from "vue";
import store from "..";

const state = {
    orderDetails: [],
    status: "",
};

const getters = {
    getOrderDetails: state => state.orderDetails,
    getOrderDetailsById(state) {
        return keyword => state.orderDetails.filter(item => {
            var id = parseInt(keyword);
            return item.ShipmentId === id
        });
    },
    isOrderDetailsHasItems: state => !!state.status.length,
    orderDetailsStatus: state => state.status
};

const actions = {
    [ORDERDETAILS_REQUEST]: ({ commit, dispatch }) => {
        commit(ORDERDETAILS_REQUEST);
        
        const ordersList = store.state.ordersList.ordersList;

        const requests = [];
        ordersList.forEach((order) => {
            const filter = [
                {
                    Filters: [
                        {
                            name: 'ShipmentId',
                            value: order.ShipmentId,
                            operator: '='
                        }
                    ]
                }
            ]
            ORDERDETAILS_params.filter = JSON.stringify(filter);        
            const params = {...ORDERDETAILS_params};
            
            requests.push(apiCalls.apiCall({ url: "get", method: "GET", params }));
        });

        Promise.all(requests)
            .then(resp => {
                resp.forEach(r => commit(ORDERDETAILS_SUCCESS, r.data));
            })
            .catch(() => {
                commit(ORDERDETAILS_ERROR);
            });
    }
};

const mutations = {
    [ORDERDETAILS_REQUEST]: state => {
        state.status = "loading";
        state.orderDetails = [];
    },
    [ORDERDETAILS_SUCCESS]: (state, resp) => {
        state.status = "success";
        resp.data.forEach((newDetail) => {
            var index = state.orderDetails.findIndex(f => f.DimensionId == newDetail.DimensionId);
            if(index >= 0){
                if(newDetail.quantity)
                    state.orderDetails[index].Quantity = newDetail.quantity;
            }
            else{
                state.orderDetails = [...state.orderDetails, newDetail]
            }
        });
        Vue.set(state, "orderDetails", state.orderDetails);
    },
    [ORDERDETAILS_ERROR]: state => {
        state.status = "error";
    },
    [SETORDERDETAILS]: (state, data) => {
        var index = state.orderDetails.findIndex(f => f.DimensionId == data.dimensionId);
        if (typeof data.value.quantity !== 'undefined')
            state.orderDetails[index].Quantity = data.value.quantity;
        if (typeof data.value.note !== 'undefined')
            state.orderDetails[index].ShipmentDimDelNote = data.value.note;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
